import React from "react";

import { LazyLoadComponent } from "widgets/lazyloader";

export const PORTAL_LOGIN_ROUTES = [
  {
    path: "/login",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "./signin/index.jsx")
        }
        componentName="SignIn"
      />
    )
  },
  {
    path: "/join",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "./signup/index.jsx")
        }
        componentName="SignUp"
      />
    )
  },
  {
    path: "/forgotpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "./forgot_password/index.jsx")
        }
        componentName="ForgotPassword"
      />
    )
  },
  {
    path: "/resetpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "./reset_password/index.jsx")
        }
        componentName="ResetPassword"
      />
    )
  },
  {
    path: "/setpassword",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(/* webpackPreload: true */ "./set_password/index.jsx")
        }
        componentName="SetPassword"
      />
    )
  },
  {
    path: "/trialexpired",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(
            /* webpackPreload: true */ "../components/trial_expired/index.jsx"
          )
        }
        componentName="TrialExpired"
      />
    )
  },
  {
    path: "/dunning",
    exact: true,
    component: (props) => (
      <LazyLoadComponent
        component={() =>
          import(
            /* webpackPreload: true */ "../components/dunning_expired/index.jsx"
          )
        }
        componentName="DunningExpired"
      />
    )
  }
];
